import { ReactNode } from "react";
import Flex from "../../../../components/Flex";
import { useQueryParams } from "../../../../hooks/use-query-param";
import { useSnackbar } from "../../../../hooks/useSnackbar";
import { ValidateDob } from "./validateDob";
import { useValidateDob } from "./dob-validation/useValidateDob";

interface DobAuthProviderProps {
  children: ReactNode;
}

export const DobAuthProvider = ({ children }: DobAuthProviderProps) => {
  const patientId: any = useQueryParams("patientId");
  const showSnackbar = useSnackbar();
  const { birthDate, setBirthDate, isAuthenticate, onVerify } = useValidateDob(
    patientId,
    showSnackbar
  );

  return (
    <Flex flexDirection={"column"} width={"100%"} gap={1} p={0.5}>
      {isAuthenticate ? (
        children
      ) : (
        <ValidateDob
          birthDate={birthDate}
          setBirthDate={setBirthDate}
          onVerify={onVerify}
        />
      )}
    </Flex>
  );
};
